import { Component, OnInit } from '@angular/core';
import { UserService } from '../../service/user/user.service';
import { User } from '../../class/user';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Candidate } from '../../class/candidate';
import { Employee } from '../../class/employee';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public users: User[];
    public selectUser: User;
    public userID: Number = 0;
    public modNew = false;
    public modView = false;
    public openUser = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;
    public query: string;

    public form3: FormGroup;
    public employee_id_filter: AbstractControl;
    public department_id_filter: AbstractControl;
    public venue_id_filter: AbstractControl;
    public first = 0;
    public filters: {key: string, value: string}[];

    public candidate: Candidate;
    public employee: Employee;

    constructor(
        public userService: UserService,
        public confirmationService: ConfirmationService,
        public translate: TranslateService,

        fb: FormBuilder) { 
            this.form3 = fb.group({
                'employee_id_filter': [''],
                'department_id_filter': [''], 
                'venue_id_filter': [''],
            });
            this.employee_id_filter = this.form3.controls['employee_id_filter'];    
            this.department_id_filter = this.form3.controls['department_id_filter'];
            this.venue_id_filter = this.form3.controls['venue_id_filter'];
        }

    ngOnInit() {
        //this.getUsers();
        this.page = 1;
        this.per_page = 10;
    }

    public loadUsersLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }

        if (event.globalFilter) {
            this.query = event.globalFilter;
        } else {
            this.query = undefined;
        }

        this.sort = '-id';
        this.getUsers(event.globalFilter);
    }

    public getUsers(query?: string) {
        this.userService.getUser(this.page, this.per_page, this.sort, query, this.filters).toPromise().then(
            response => {
                this.users = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newUser() {
        this.modNew = !this.modNew;
        this.selectUser = null;
    }

    public savedUser(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectUser = null;
        this.modNew = false;
        this.getUsers();
    }

    public cancelUser (res) {
        this.selectUser = null;
        this.modNew = false;
        this.modView = false;
        this.getUsers();
    }

    public edit(user: User) {
        this.modNew = true;
        this.selectUser = user;
        this.getUsers();
    }

    public view(user: User) {
        this.openUser = true;
        this.selectUser = user;
        this.userID = user.id;
        this.modView = true;
    }

    public deleteDialog(user: User) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(user);
            }
        });
    }

    public delete(user: User) {
        this.userService.deleteUser(user.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'Usuario borrado satisfactoriamente' } );
                this.getUsers();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeUser(user: User) {
        this.putUser(user);
    }

    public filter (values) {
        this.page = 1;
        this.first = 0;

        this.filters = [];
        if (values.employee_id_filter) {
            this.filters.push({'key': 'employee_id-lk', 'value': values.employee_id_filter.id});
        }
        if (values.department_id_filter) {
            this.filters.push({'key': 'employee.department_id-lk', 'value': values.department_id_filter});
        }
        if (values.venue_id_filter) {
            this.filters.push({'key': 'employee.venue_id-lk', 'value': values.venue_id_filter})
        }
        this.getUsers();
    }

    public putUser(values: User) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.userService.updateUser(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/users/users.component.ts